export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./start.html?vue&type=template&id=373f9e07&"